import { use, useEffect, useState } from 'react'

import DOMPurify from 'dompurify'

import { fetchRawEmailContent } from '@app/api'
import { ChatContext } from '@app/context'
import { useConversationActorRole } from '@app/hooks'
import { trackViewEmail } from '@app/services/tracking'

import { isCanceledError } from '@app/utils/errors'

import { Loader } from '@lib/components'

import { MessageEmailContent } from './MessageEmailContent'

import { MessageEmailContainerProps } from './types'

export const MessageEmailContentContainer = ({
  abortController,
  conversation,
  message,
}: MessageEmailContainerProps) => {
  const { state } = use(ChatContext)
  const conversationActorRole = useConversationActorRole()
  const [email, setEmail] = useState('')
  const [fetching, setFetching] = useState(false)
  const listing =
    (conversation.context?.listingId &&
      state.listings.get(conversation.context.listingId)) ||
    null

  useEffect(() => {
    if (fetching) return
    ;(async () => {
      setFetching(true)
      try {
        trackViewEmail(conversation.id, listing, conversationActorRole)
        const controller = abortController()
        const { rawEmailContent: body } = await fetchRawEmailContent(
          conversation.id,
          message.id,
          controller?.signal
        )
        const sanitizedContent = DOMPurify.sanitize(body)
        setEmail(sanitizedContent || '')
      } catch (error: unknown) {
        if (isCanceledError(error)) {
          console.log('Fetch request was cancelled')
        } else {
          console.error(error)
        }
      } finally {
        setFetching(false)
      }
    })()
  }, [])

  if (!email) return <Loader />
  return <MessageEmailContent email={email} />
}
